function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGoogleCalendarIntegrationIcon = function SvgGoogleCalendarIntegrationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    style: {
      enableBackground: "new 0 0 122.88 122.88"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M93.78 29.1H29.1v64.68h64.68V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f72a25"
    },
    d: "m93.78 122.88 29.1-29.1h-29.1v29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fbbc04"
    },
    d: "M122.88 29.1h-29.1v64.68h29.1V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34a853"
    },
    d: "M93.78 93.78H29.1v29.1h64.68v-29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 93.78v19.4c0 5.36 4.34 9.7 9.7 9.7h19.4v-29.1H0z",
    style: {
      fill: "#188038"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.88 29.1V9.7c0-5.36-4.34-9.7-9.7-9.7h-19.4v29.1h29.1z",
    style: {
      fill: "#1967d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.78 0H9.7C4.34 0 0 4.34 0 9.7v84.08h29.1V29.1h64.67V0h.01z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.37 79.27c-2.42-1.63-4.09-4.02-5-7.17l5.61-2.31c.51 1.94 1.4 3.44 2.67 4.51 1.26 1.07 2.8 1.59 4.59 1.59 1.84 0 3.41-.56 4.73-1.67 1.32-1.12 1.98-2.54 1.98-4.26 0-1.76-.7-3.2-2.09-4.32s-3.14-1.67-5.22-1.67H46.4v-5.55h2.91c1.79 0 3.31-.48 4.54-1.46 1.23-.97 1.84-2.3 1.84-3.99 0-1.5-.55-2.7-1.65-3.6s-2.49-1.35-4.18-1.35c-1.65 0-2.96.44-3.93 1.32-.97.88-1.7 2-2.12 3.24l-5.55-2.31c.74-2.09 2.09-3.93 4.07-5.52 1.98-1.59 4.51-2.39 7.58-2.39 2.27 0 4.32.44 6.13 1.32 1.81.88 3.23 2.1 4.26 3.65 1.03 1.56 1.54 3.31 1.54 5.25 0 1.98-.48 3.65-1.43 5.03-.95 1.37-2.13 2.43-3.52 3.16v.33c1.79.74 3.36 1.96 4.51 3.52 1.17 1.58 1.76 3.46 1.76 5.66s-.56 4.16-1.67 5.88c-1.12 1.72-2.66 3.08-4.62 4.07-1.96.99-4.17 1.49-6.62 1.49-2.84 0-5.46-.81-7.88-2.45zm34.46-27.84-6.16 4.45-3.08-4.67 11.05-7.97h4.24v37.6h-6.05V51.43z",
    style: {
      fill: "#1a73e8"
    }
  }));
};

export default SvgGoogleCalendarIntegrationIcon;